import { jsx } from "react/jsx-runtime";
import { forwardRef, memo, useCallback, useEffect, useImperativeHandle, useRef } from "react";
import { isElementReference } from "../../../state/react-page";
import { ElementImperativeHandle } from "../element-imperative-handle";
import { useDispatch } from "../hooks/use-dispatch";
import { useDocumentKey } from "../hooks/use-document-key";
import { useDisableRegisterElement } from "../hooks/use-disable-register-element";
import { mountComponentEffect, registerComponentHandleEffect } from "../../../state/actions";
import { ElementReference } from "./ElementReference";
import { ElementData } from "./ElementData";
import { FindDomNode } from "../find-dom-node";
const Element = memo(
  forwardRef(function Element2({ element }, ref) {
    const elementKey = element.key;
    const dispatch = useDispatch();
    const documentKey = useDocumentKey();
    const useFindDomNodeRef = useRef(true);
    const imperativeHandleRef = useRef(new ElementImperativeHandle());
    const findDomNodeCallbackRef = useCallback((current) => {
      if (useFindDomNodeRef.current === true) {
        imperativeHandleRef.current.callback(() => current?.() ?? null);
      }
    }, []);
    const elementCallbackRef = useCallback((current) => {
      useFindDomNodeRef.current = false;
      imperativeHandleRef.current.callback(() => current);
    }, []);
    const isRegisterElementDisabled = useDisableRegisterElement();
    useImperativeHandle(ref, () => imperativeHandleRef.current, []);
    useEffect(() => {
      if (documentKey == null || isRegisterElementDisabled)
        return;
      return dispatch(
        registerComponentHandleEffect(documentKey, elementKey, imperativeHandleRef.current)
      );
    }, [dispatch, documentKey, elementKey, isRegisterElementDisabled]);
    useEffect(() => {
      if (documentKey == null || isRegisterElementDisabled)
        return;
      return dispatch(mountComponentEffect(documentKey, elementKey));
    }, [dispatch, documentKey, elementKey, isRegisterElementDisabled]);
    return /* @__PURE__ */ jsx(FindDomNode, { ref: findDomNodeCallbackRef, children: isElementReference(element) ? /* @__PURE__ */ jsx(ElementReference, { ref: elementCallbackRef, elementReference: element }, elementKey) : /* @__PURE__ */ jsx(ElementData, { ref: elementCallbackRef, elementData: element }, elementKey) });
  })
);
export {
  Element
};
//# sourceMappingURL=Element.js.map